import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import EmojiSelectorTabs from "~/core-ui/vue/ui/emoji-selector/EmojiSelectorTabs.vue";
import OperatorApplicationSelectableStickerList
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationSelectableStickerList.vue";
import EmojiSelectTabIcon from "~/core-ui/vue/ui/emoji-selector/EmojiSelectTabIcon.vue";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {computed, ref} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import Modernizr from "~/operatorApplication/ts/OperatorApplicationModernizer";
import {OPERATOR_EMOJI_UNICODE_TO_SHORT} from "~/operatorApplication/ts/OperatorApplicationEmojiMap";
import {__} from "~/ts/library/Translate";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "EmojiButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, focusTextarea, sendMessage} = useTextareaComponent();

let button = ref<InstanceType<typeof OperatorApplicationDialogTextareaButton> | null>();

let isEmojiSelectorDisplayed = ref(false);

let availableStickerPacks = computed(
    () => OperatorAccountStore.data.value.stickerPacks.filter(stickerPack => {
        return !stickerPack.siteIds || stickerPack.siteIds.includes(client.value.siteId)
    })
);

function sendSticker(sticker: OperatorApplicationApi.OperatorApplicationStickerOpenApiModel) {
    sendMessage(null, sticker);
    button.value.closeDropdown();
    focusTextarea();
}

function appendEmoji(emoji: string) {
    button.value.closeDropdown();
    focusTextarea();
    OperatorApplicationConfigInstance.addFavoriteEmoji(emoji);
    if (!(Modernizr as any).emoji) {
        emoji = OPERATOR_EMOJI_UNICODE_TO_SHORT[emoji] ?? emoji;
    }

    document.execCommand('insertText', false, emoji);
}



return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!

  return (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
    icon: "smile",
    tooltip: _unref(__)('Смайлики'),
    ref_key: "button",
    ref: button
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, { class: "overflow-hidden" }, {
        default: _withCtx(() => [
          (_unref(button)?.isDropdownWasVisible)
            ? (_openBlock(), _createBlock(EmojiSelectorTabs, {
                key: 0,
                favorite: _unref(OperatorApplicationConfigInstance).favoriteEmoji,
                onSelect: appendEmoji
              }, _createSlots({ _: 2 }, [
                (_unref(availableStickerPacks).length)
                  ? {
                      name: "before-first",
                      fn: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, { name: "stickers" }, {
                          label: _withCtx(() => [
                            _createVNode(EmojiSelectTabIcon, { icon: "sticky-note" })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(OperatorApplicationSelectableStickerList, {
                              "sticker-packs": _unref(availableStickerPacks),
                              onSelect: sendSticker
                            }, null, 8, ["sticker-packs"])
                          ]),
                          _: 1
                        })
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["favorite"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["tooltip"]))
}
}

})